import { motion } from "framer-motion";
import { Box } from "@mui/material";

const LogoAnimation = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <motion.img
        src="/ozbek-logo.png" // Resmin doğru konumda olduğundan emin ol
        alt="Özbek Logo"
        initial={{ clipPath: "inset(100% 0% 0% 0%)", opacity: 0 }}
        animate={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        style={{ width: "500px", height: "auto" }} // Logonun boyutunu ayarla
      />
    </Box>
  );
};

export default LogoAnimation;
